import React, { useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import axios from "axios";
import BtnLoader from "Components/Common/Loader/BtnLoader";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 400,
  bgcolor: "background.paper",
  border: "none",
  borderRadius: 8,
  boxShadow: 24,
  p: 4,
};

const EmojiWarningPopup = ({
  warnPopupOpen,
  handleClose,
  emojiDetails,
  fetchAllEmojis,
  staffId,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const createStaffActivityLog = async (actionType, description, staffId) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/staffs-activity-log/create-staffs-activity`,
        {
          staff: staffId,
          action: actionType,
          description,
        }
      );
    } catch (error) {
      console.error("Activity log failed:", error.message);
    }
  };

  const deleteEmoji = () => {
    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/emoji-package/delete-emoji-packages/${emojiDetails?._id}`,
      headers: {},
      data: "",
    };

    setIsLoading(true);
    axios.request(config).then(async (response) => {
      setIsLoading(false);

      //  ACTIVITY LOG
      await createStaffActivityLog(
        "DELETE_EMOJI",
        `Emoji Gift Deleted:
       Name: ${emojiDetails?.name} |
       Emoji: ${emojiDetails?.emoji} |
       Price: ₹${emojiDetails?.coinDeduct}`,
        staffId
      );

      handleClose();
      fetchAllEmojis();
    });
  };

  return (
    <Modal
      open={warnPopupOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className="w-full">
          <div className="mb-4 flex items-center">
            <div className="mr-3 h-16 w-16 flex-shrink-0">
              <img
                src={emojiDetails?.emoji}
                alt={emojiDetails?.name}
                className="h-full w-full rounded object-contain"
              />
            </div>
            <h2 className="text-xl font-semibold tracking-wide">
              {emojiDetails?.name}
            </h2>
          </div>
          <p className="mb-6 tracking-wide">
            Do you really want to delete this Gift?
          </p>
          <div className="flex justify-end space-x-4 tracking-wide">
            <button
              className="rounded bg-gray-300 px-4 py-2 text-gray-800 hover:bg-gray-400"
              onClick={handleClose}
            >
              Cancel
            </button>

            {isLoading ? (
              <button className="rounded bg-[#c51369] px-4 py-2 text-white hover:bg-[#a10f5b]">
                <BtnLoader />
              </button>
            ) : (
              <button
                onClick={deleteEmoji}
                className="rounded bg-[#c51369] px-4 py-2 text-white hover:bg-[#a10f5b]"
              >
                Yes, Delete
              </button>
            )}
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default EmojiWarningPopup;
